import { useEffect, useState } from "react";
import { AlarmClock } from "lucide-react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";

export const DueTasksCard = ({ onOpenClient, refreshKey }) => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/crm/tasks/due").then((r) => setData(r.data)).catch(() => setData(null)); }, [refreshKey]);
  if (!data?.tasks?.length) return null;
  const late = data.tasks.filter((t) => t.due_date < data.today).length;
  return (
    <Card className="p-4 border-amber-300/60 bg-amber-50/60 dark:bg-amber-950/20" data-testid="crm-due-tasks">
      <div className="flex items-center gap-2 text-sm font-semibold">
        <AlarmClock className="h-4 w-4 text-amber-600" /> Relances CRM : {data.tasks.length - late} aujourd'hui{late ? `, ${late} en retard` : ""}
      </div>
      <div className="mt-2 grid sm:grid-cols-2 gap-1.5">
        {data.tasks.slice(0, 8).map((t) => (
          <button key={t.id} onClick={() => onOpenClient(t.client_id)} className="text-left text-xs rounded-md px-2 py-1.5 hover:bg-amber-100/70 dark:hover:bg-amber-900/30 transition-colors" data-testid={`crm-due-${t.id}`}>
            <span className={t.due_date < data.today ? "text-red-600 font-semibold" : "text-amber-700 dark:text-amber-400 font-semibold"}>{t.due_date.split("-").reverse().join("/")}</span>
            {" · "}<b>{t.client_name}</b> — {t.title}
          </button>
        ))}
      </div>
    </Card>
  );
};
